import withCheckbox from './withCheckbox'
import Select from '.'

const SelectWithCheckbox = withCheckbox(Select)

export default SelectWithCheckbox
